import {KeyboardEvent} from "react";
import {useFocusManager} from "react-aria";

type NavigationOrientation = "horizontal" | "vertical";

type UseArrowKeyNavigationOptions = {
	shouldWrap?: boolean;
	preventDefault?: boolean;
	orientation?: NavigationOrientation;
};

export const OrientationMap: Record<string, NavigationOrientation> = {
	DEFAULT: "horizontal",
	HORIZONTAL: "horizontal",
	VERTICAL: "vertical",
};

function useArrowKeyNavigation({
	shouldWrap = true,
	preventDefault = false,
	orientation = OrientationMap.DEFAULT,
}: UseArrowKeyNavigationOptions = {}) {
	const focusManager = useFocusManager();
	const focusNextKey =
		orientation === OrientationMap.HORIZONTAL ? "ArrowRight" : "ArrowDown";
	const focusPrevKey =
		orientation === OrientationMap.HORIZONTAL ? "ArrowLeft" : "ArrowUp";
	const onKeyDown = (e: KeyboardEvent<any>) => {
		switch (e.key) {
			case focusNextKey:
				if (preventDefault) {
					e.preventDefault();
				}
				focusManager?.focusNext({wrap: shouldWrap});
				break;
			case focusPrevKey:
				if (preventDefault) {
					e.preventDefault();
				}
				focusManager?.focusPrevious({wrap: shouldWrap});
				break;
		}
	};
	return onKeyDown;
}

export default useArrowKeyNavigation;
